import { Injectable } from '@angular/core';
import { ServiceBase } from '../../shared/models/bases/serviceBase';
import { API_ENDPOINTS } from '../../shared/common/apiConstants';
import { BusinessProfessionalCount } from '../../shared/models/business';
import { BusinessProfessionalCountStore } from '../../stores/business';

@Injectable({ providedIn: 'root' })
export class BusinessProfessionalCountService extends ServiceBase<BusinessProfessionalCount> {
  constructor(businessProfessionalCountStore: BusinessProfessionalCountStore) {
    super(
      API_ENDPOINTS.businesses.professionalCount,
      businessProfessionalCountStore,
    );
  }
}
